export default "__VITE_ASSET__46701bf7__$_?react__"